<template>

	<div class="item-block-view">

		<div class="row">
			<div class="col-xs-12">
				<div class="clearfix index-title-block">
					<div class="pull-left index-title">
						{{block.name}}
					</div>
					<div class="pull-right index-title-more">

					</div>
				</div>
			</div>
		</div>
		<div class="row mt10">

			<div class="col-xs-12" v-for="item in block.items">
				<div class="media hot-block">

					<div class="pull-right time">

					</div>
					<div class="media-body title" @click="item.click(topic)">
						{{item.name}}
					</div>

				</div>

			</div>

		</div>
	</div>


</template>


<script>

	import Block from '../../../../common/model/lover/theme/Block'
	import Item from '../../../../common/model/lover/theme/Item'

	export default {

		props: {
			block: {
				type: Block,
				required: false,
				"default": false
			}
		},
		data() {
			return {

			};
		},
		computed: {
			topic(){
				return this.$route.meta.topic;
			}
		},
		watch: {},

		methods: {

		},
		mounted(){

		}
	};
</script>


<style lang="less" rel="stylesheet/less">

	.item-block-view {
		margin-bottom: 20px;
		.title {
			cursor: pointer;
			color: #555;

			&:hover {
				color: #000;
				text-decoration: underline;
			}
			font-size: 13px;

			line-height: 22px;
			white-space: nowrap;
			text-overflow: ellipsis;

		}
		.time {
			line-height: 22px;
			color: #aaaaaa;
		}

		.index-title-block {
			border-bottom: 1px solid #bbbbbb;

			.index-title {
				font-size: 18px;
				padding: 3px 0 5px;
				border: none;
				color: #666666;
				line-height: 30px;
				font-weight: bold;
			}
			.index-title-more {
				padding-top: 10px;
			}

		}

	}
</style>




// WEBPACK FOOTER //
// ItemBlock.vue?049cc71c